/** The speech bubble the routes screens use for notes: the setter's and climbers'. */
export function CommentIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        d="M10 2c-4.418 0-8 2.91-8 6.5 0 1.84.94 3.5 2.454 4.68a.5.5 0 0 1 .186.457l-.19 1.6a.5.5 0 0 0 .72.5l2.2-1.16a.5.5 0 0 1 .35-.05A9.6 9.6 0 0 0 10 15c4.418 0 8-2.91 8-6.5S14.418 2 10 2Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
